/**
 * Fragment de routes du paquet v7-p02-pilotage-ecrans (vague V7, règle R2 du découpage V4–V11 : un fragment par paquet).
 * Composants chargés à la demande (règle de chargement du registre), aucun code exécuté au chargement.
 * Route du socle remplacée (`remplace: true`), d'après le `couvre: route:/programme/versions` du YAML de
 * programme-versions : l'écran historique `screens/niveaux/programme/VersionsProgramme` n'est plus servi ; son fichier
 * et App.tsx (gelé) restent inchangés. Routes neuves (programme par `?programme=`, sinon celui de la coquille) :
 *  - `/programme/calendrier` (programme-calendrier-livraisons), `/programme/calendrier/livraison?livraison=`
 *    (programme-livraison-fiche), `/programme/calendrier/gel?gel=` (programme-gel-fiche) ;
 *  - `/programme/versions/fiche?version=` (programme-version-fiche) ; `/programme/roadmap/repere?repere=`
 *    (programme-repere-fiche) ;
 *  - `/programme/reglages/objectif-registre` (programme-objectif-registre) ;
 *  - `/programme/backlog/objectif?initiative=` (dialogue-objectif-element-de-tete, dialogue en écran plein).
 */
import { lazy, Suspense, type ComponentType, type JSX } from 'react'

import type { Session } from '../../auth/session'
import type { ContexteRoutes, FragmentRoutes } from './registre'

const ProgrammeCalendrierLivraisons = lazy(() => import('../ecrans/v7/pilotage/ProgrammeCalendrierLivraisons'))
const ProgrammeLivraisonFiche = lazy(() => import('../ecrans/v7/pilotage/ProgrammeLivraisonFiche'))
const ProgrammeGelFiche = lazy(() => import('../ecrans/v7/pilotage/ProgrammeGelFiche'))
const ProgrammeVersions = lazy(() => import('../ecrans/v7/pilotage/ProgrammeVersions'))
const ProgrammeVersionFiche = lazy(() => import('../ecrans/v7/pilotage/ProgrammeVersionFiche'))
const ProgrammeRepereFiche = lazy(() => import('../ecrans/v7/pilotage/ProgrammeRepereFiche'))
const ProgrammeObjectifRegistre = lazy(() => import('../ecrans/v7/pilotage/ProgrammeObjectifRegistre'))
const DialogueObjectifElementDeTete = lazy(() => import('../ecrans/v7/pilotage/DialogueObjectifElementDeTete'))

function ecran(Composant: ComponentType<{ session: Session }>) {
  return ({ session, t }: ContexteRoutes): JSX.Element => (
    <Suspense fallback={<p role="status">{t('v10.primitives.assemblage.chargement')}</p>}>
      <Composant session={session} />
    </Suspense>
  )
}

export const fragment: FragmentRoutes = {
  zone: 'v7-pilotage',
  routes: [
    { chemin: '/programme/versions', element: ecran(ProgrammeVersions), remplace: true },
    { chemin: '/programme/versions/fiche', element: ecran(ProgrammeVersionFiche) },
    { chemin: '/programme/calendrier', element: ecran(ProgrammeCalendrierLivraisons) },
    { chemin: '/programme/calendrier/livraison', element: ecran(ProgrammeLivraisonFiche) },
    { chemin: '/programme/calendrier/gel', element: ecran(ProgrammeGelFiche) },
    { chemin: '/programme/roadmap/repere', element: ecran(ProgrammeRepereFiche) },
    { chemin: '/programme/reglages/objectif-registre', element: ecran(ProgrammeObjectifRegistre) },
    { chemin: '/programme/backlog/objectif', element: ecran(DialogueObjectifElementDeTete) },
  ],
}
